
import { Logo } from "../components/logo";

export function Footer() {

  return (

    <footer className="mt-11">

      <Logo variant="footer" />

      <div className="bg-blue-primary px-6 sm:px-8 lg:px-24 py-16 sm:py-28">

        <div className="max-w-6xl mx-auto">

          <h2 className="mb-12 font-bold text-white text-center">PIONEERING DIAGNOSTICS</h2>

          <div className="max-w-5xl mx-auto text-xs text-white text-center">

            <p>

              &copy; <span data-use-full-year>2025</span> bioMérieux, Inc. 
              
              <span className="font-extrabold"> &middot; </span> 
              
              <a className="underline" href="https://www.biomerieux-usa.com/patents">Patents</a> 
              
              <span className="font-extrabold"> &middot; </span> 
              
              515 Colorow Drive, Salt Lake City, UT 84108 
              
              <span className="font-extrabold"> &middot; </span> 
              
              Tel: <a href="tel:+18006347656">(800) 634-7656</a> 
              
              <span className="font-extrabold"> &middot; </span> 
              
              <a className="underline" href="https://www.biomerieux.com/us/en/privacy/protection-of-personal-information-and-commitment-to-privacy.html">Privacy Policy</a> 
              
              <span className="font-extrabold"> &middot; </span> 
              
              BMX.1.178935 Rev01.A

            </p>

          </div>

        </div>

      </div>

    </footer>
    
  );

}
